'use strict';

/**
 * Updates sitevibes product data id and triggers
 * another event to SiteVibes
 * @param product - The selected variant product
 */
function updateSiteVibesProductDataId(product) {

    // Call the siteVibes event to update the product data TO sitevibes with selected product
    if(window.SiteVibesEvents) {
        // Trigger the event to SiteVibes to update the product data
        // svData is on the product object via a decorator:
        SiteVibesEvents.productData(product.svData);
    }
    
    if(window.SiteVibesProductData) {

        // Clear out any existing widgets so that they are still in the DOM, but empty and
        // do not display any data from initial page load
        $('sv-product-social-proof div').each(function() {
            $(this).empty();
        });

        // Update the product data id in the sitevibes element on the page
        // This will cause siteVibes to update the product data on the page with its widget
        setTimeout(function() {
            $('sv-product-social-proof').attr('data-product-id', product.id);
        }, 10);

    }


}

module.exports = {
    updateSiteVibesProductDataId: updateSiteVibesProductDataId
}